export const motAutorizadorRoutes = {
    path: '/autorizadorfinanceiro/mao-de-obra-temporaria',
    redirect: { name: 'Listagem_MOT_Autorizador_Aguardando' },
    meta: {
        rules: ['AUTORIZADOR-MOT-00'],
    },
    children: [
        {
            path: 'aguardando',
            name: 'Listagem_MOT_Autorizador_Aguardando',
            component: () => import('./MotAutorizador.vue'),
            meta: { rules: ['AUTORIZADOR-MOT-00'] },
        },
        {
            path: 'aprovados',
            name: 'Listagem_MOT_Autorizador_Aprovados',
            component: () => import('./MotAutorizador.vue'),
            meta: { rules: ['AUTORIZADOR-MOT-00'] },
        },
        {
            path: 'reprovados',
            name: 'Listagem_MOT_Autorizador_Reprovados',
            component: () => import('./MotAutorizador.vue'),
            meta: { rules: ['AUTORIZADOR-MOT-00'] },
        },
        {
            path: ':id',
            name: 'Detalhar_MOT_Autorizador',
            component: () => import('./Detalhar.vue'),
            meta: { rules: ['AUTORIZADOR-MOT-00'] },
        },
    ],
};
